module.exports = __webpack_public_path__ + "img/IMG_2399_T_L_WoodMatted_MockedUp.534fee51.jpg";